const classPrefix = 'locations'
const dataPrefix = 'data-locations'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    locations()
}
export function locations() {

}
